import { Box, DialogContent, Divider, IconButton, ModalDialog, Stack, Typography } from '@mui/joy';
import { FC } from 'react';
import { TfiClose } from 'react-icons/tfi';
import QRCode from 'react-qr-code';

import { RectangleButton } from '@MP/shared/components/Button';

export const QRCodeModalDialog: FC<{
  url: string;
  loading?: boolean;
  validPhone?: boolean;
  onClose: () => void;
  onSend: () => void;
}> = ({ url, validPhone, loading, onClose, onSend }) => {
  return (
    <ModalDialog sx={{ gap: '16px' }}>
      <Stack direction={'row'} justifyContent={'space-between'} alignItems={'flex-start'}>
        <Box>
          <Typography level="h4" fontWeight={600}>
            약관 동의 QR 코드
          </Typography>
          {validPhone && (
            <Typography level="body-sm" fontWeight={500} sx={{ color: '#999999' }}>
              * 환자 휴대전화로 설문을 보내거나, QR 코드 스캔 후 약관 동의를 진행해 주세요.
            </Typography>
          )}
          {!validPhone && (
            <Typography level="body-sm" fontWeight={500} sx={{ color: '#999999' }}>
              * QR 코드 스캔 후 약관 동의를 진행해 주세요.
            </Typography>
          )}
        </Box>
        <IconButton onClick={onClose}>
          <TfiClose fontSize={20} />
        </IconButton>
      </Stack>

      <DialogContent sx={{ width: 620 }}>
        <Stack gap={'16px'}>
          <Stack alignItems={'center'}>
            <QRCode value={url} />
          </Stack>
          <Divider />
          <Stack direction={'row'} justifyContent={'flex-end'} spacing={'8px'}>
            {validPhone && (
              <RectangleButton variant="outlined" onClick={onSend} loading={loading}>
                보내기
              </RectangleButton>
            )}
            <RectangleButton onClick={onClose}>완료</RectangleButton>
          </Stack>
        </Stack>
      </DialogContent>
    </ModalDialog>
  );
};
